import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Drawer, Input } from "antd5";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  initialQuestionText?: string;
  onSave: (questionText: string) => void;
};

export default function AddOrEditQuestionDrawer({
  isOpen,
  onClose,
  initialQuestionText,
  onSave,
}: Props): JSX.Element {
  const isEdit = initialQuestionText !== undefined;
  const [questionText, setQuestionText] = useState(initialQuestionText ?? "");

  useEffect(() => {
    setQuestionText(initialQuestionText ?? "");
  }, [initialQuestionText]);

  const handleClose = () => {
    setQuestionText("");
    onClose();
  };

  const handleSave = () => {
    const trimmed = questionText.trim();
    if (!trimmed) return;
    onSave(trimmed);
    handleClose();
  };

  return (
    <Drawer
      placement="right"
      closable
      open={isOpen}
      width={440}
      onClose={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      styles={{ header: { display: "none" }, body: { padding: "24px" } }}
    >
      <Flex justifyContent="space-between" height="100%" flexDirection="column">
        <Flex flexDirection="column" gap={16}>
          <Text h3>{isEdit ? "Edit" : "Add"} question</Text>
          <Description>
            What are you trying to understand from within the tender documents? Phrase this as a
            question. The more specific and precise the better.
          </Description>
          <Input.TextArea
            value={questionText}
            onChange={(e) => setQuestionText(e.target.value)}
            autoFocus
            autoSize={{ minRows: 3 }}
            placeholder="Enter your qualification question"
          />
        </Flex>
        <Flex gap={8} alignItems="center" justifyContent="flex-end">
          <Button buttonType="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button disabled={!questionText.trim()} onClick={handleSave}>
            Save
          </Button>
        </Flex>
      </Flex>
    </Drawer>
  );
}

const Description = styled(Text)(({ theme }) => ({
  color: theme.colors.sysTextSecondary,
  fontSize: 12,
}));
